import { adminEntryUrl, publicSiteIdentity } from "./lib/bookingHost";
import "./legal.css";

export function SiteFooter() {
  const identity = publicSiteIdentity();

  return (
    <>
      <footer className="site-footer">
        <a className="site-footer__brand" href={identity.siteUrl}>
          {identity.brand}
        </a>
        <nav className="site-footer__nav" aria-label="Rechtliches und Kontakt">
          <a href="https://katrinundrayk.de/">Katrin &amp; Rayk</a>
          <a href="/impressum">Impressum</a>
          <a href="/datenschutz">Datenschutz</a>
          <a href={`mailto:${identity.contactMail}`}>{identity.contactMail}</a>
          <a className="site-footer__domain" href={identity.siteUrl}>
            {identity.domain}
          </a>
        </nav>
      </footer>

      <a className="site-admin-bubble" href={adminEntryUrl()} aria-label="Verwaltung öffnen">
        <span className="site-admin-bubble__dot" aria-hidden="true" />
        <span>Verwaltung</span>
      </a>
    </>
  );
}
